type ProfileIdentity = {
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  email?: string | null;
};

/** Up to two characters for avatar fallback: name → username → email local-part. */
export function getProfileInitials(user?: ProfileIdentity | null): string {
  if (!user) return '?';

  const first = (user.firstName || '').trim();
  const last = (user.lastName || '').trim();

  if (first || last) {
    const a = first.charAt(0);
    const b = last.charAt(0);
    if (a && b) return `${a}${b}`.toUpperCase();
    const combined = `${first}${last}`.replace(/\s+/g, '');
    return (combined || '?').slice(0, 2).toUpperCase();
  }

  const username = (user.username || '').trim();
  if (username) {
    const clean = username.replace(/[^a-zA-Z0-9]/g, '');
    return (clean || username).slice(0, 2).toUpperCase();
  }

  const email = (user.email || '').trim();
  if (email) {
    const local = (email.split('@')[0] || email).trim();
    const clean = local.replace(/[^a-zA-Z0-9]/g, '');
    return (clean || local).slice(0, 2).toUpperCase();
  }

  return '?';
}
